import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-actions"
};
const _hoisted_4 = {
  class: "status-badge is-warning"
};
const _hoisted_5 = {
  class: "status-badge is-info"
};
const _hoisted_6 = {
  class: "status-badge is-success"
};
const _hoisted_7 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_8 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_9 = {
  class: "data-table-shell"
};
const _hoisted_10 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_11 = {
  class: "data-table text-sm min-w-[1080px]"
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  class: "data-table-td"
};
const _hoisted_14 = {
  class: "max-w-xs"
};
const _hoisted_15 = ["title"];
const _hoisted_16 = ["title"];
const _hoisted_17 = {
  key: 1,
  class: "mt-1.5 flex items-center gap-1.5"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 0,
  class: "flex h-10 w-10 items-center justify-center rounded-md bg-slate-100 text-xs text-slate-500"
};
const _hoisted_20 = {
  class: "data-table-td"
};
const _hoisted_21 = {
  class: "text-slate-800"
};
const _hoisted_22 = {
  key: 0,
  class: "data-table-cell-meta mt-0.5"
};
const _hoisted_23 = {
  class: "data-table-td text-center"
};
const _hoisted_24 = {
  class: "data-table-td text-center text-slate-600"
};
const _hoisted_25 = {
  class: "data-table-td text-center text-xs text-slate-500"
};
const _hoisted_26 = {
  class: "data-table-td text-center text-xs text-slate-500"
};
const _hoisted_27 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_28 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["onClick"];
const _hoisted_31 = ["onClick"];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  key: 3,
  class: "text-xs text-slate-300"
};
import { ref, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useRouter } from 'vue-router';
import { usePagination } from '@/composables/usePagination';
import { useSearch } from '@/composables/useSearch';
import { getDemandPage, assignDemand, claimDemand, rejectDemand, closeDemand } from '@/api/demand';
import { createSingleConversation } from '@/api/chat';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import DemandAssignModal from './components/DemandAssignModal.vue';
export default {
  __name: 'DemandManagement',
  setup(__props) {
    const router = useRouter();

    // 数据
    const loading = ref(false);
    const demandList = ref([]);

    // 分页
    const {
      pagination,
      goToPage,
      setPageSize,
      updatePagination,
      getPaginationParams
    } = usePagination();

    // 搜索
    const {
      searchForm,
      handleSearch: triggerSearch,
      resetSearch,
      getSearchParams
    } = useSearch({
      initialForm: {
        status: ''
      },
      onSearch: fetchData
    });

    // 分配窗口
    const showAssignModal = ref(false);
    const assignItem = ref(null);
    const assignModalRef = ref();

    // status summary
    const statusCounts = ref({
      pending: 0,
      processing: 0,
      completed: 0,
      closed: 0
    });

    // 状态选项：0-待处理，1-处理中，2-已完成，3-已关闭
    const statusOptions = [{
      label: '全部状态',
      value: ''
    }, {
      label: '待处理',
      value: 0
    }, {
      label: '处理中',
      value: 1
    }, {
      label: '已完成',
      value: 2
    }, {
      label: '已关闭',
      value: 3
    }];
    const statusText = status => ({
      0: '待处理',
      1: '处理中',
      2: '已完成',
      3: '已关闭'
    })[status] ?? '-';
    const statusBadgeClass = status => ({
      0: 'status-badge is-warning',
      1: 'status-badge is-info',
      2: 'status-badge is-success',
      3: 'status-badge is-neutral'
    })[status] || 'status-badge is-neutral';

    // 凭证图片列表
    const getImageList = item => {
      if (!item.images) return [];
      return item.images.split(',').filter(Boolean);
    };

    // 表格时间展示（YYYY-MM-DD HH:mm）
    const formatTime = timeStr => timeStr ? timeStr.slice(0, 16) : '-';

    // 获取数据
    async function fetchData() {
      loading.value = true;
      try {
        const params = {
          ...getSearchParams(),
          ...getPaginationParams()
        };
        const data = await getDemandPage(params);
        demandList.value = data.records || [];
        updatePagination(data);
        // 更新统计（如果后端返回）
        if (data.statusCounts) {
          statusCounts.value = data.statusCounts;
        }
      } catch (error) {
        ElMessage.error('加载需求列表失败');
        console.error('加载需求列表失败', error);
      } finally {
        loading.value = false;
      }
    }

    // 筛选变化
    const handleFilterChange = () => {
      pagination.current = 1;
      fetchData();
    };

    // 换页
    const changePage = page => {
      goToPage(page);
      fetchData();
    };

    // 切换每页条数
    const changePageSize = size => {
      setPageSize(size);
      fetchData();
    };

    // ========== 操作 ==========

    // 分配
    const handleAssign = item => {
      assignItem.value = item;
      showAssignModal.value = true;
    };
    const handleAssignConfirm = async ({
      demandId,
      handlerId
    }) => {
      try {
        await assignDemand(demandId, handlerId);
        ElMessage.success('分配成功');
        assignModalRef.value?.done();
        fetchData();
      } catch (error) {
        ElMessage.error(error.message || '分配失败');
        assignModalRef.value?.done();
      }
    };

    // 认领
    const handleClaim = async item => {
      try {
        await ElMessageBox.confirm('确定认领此需求吗？认领后您将成为此需求的处理人。', '确认认领', {
          confirmButtonText: '确认认领',
          cancelButtonText: '取消',
          type: 'info'
        });
        await claimDemand(item.id);
        ElMessage.success('认领成功');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error(error.message || '认领失败');
        }
      }
    };

    // 拒绝
    const handleReject = async item => {
      try {
        const {
          value: remark
        } = await ElMessageBox.prompt('请输入拒绝原因（可选）', '拒绝需求', {
          confirmButtonText: '确认拒绝',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputPlaceholder: '请输入拒绝原因...',
          type: 'warning'
        });
        await rejectDemand(item.id, remark);
        ElMessage.success('已拒绝');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error(error.message || '操作失败');
        }
      }
    };

    // 关闭
    const handleClose = async item => {
      try {
        await ElMessageBox.confirm('确定关闭此需求吗？', '关闭需求', {
          confirmButtonText: '确认关闭',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await closeDemand(item.id);
        ElMessage.success('已关闭');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error(error.message || '操作失败');
        }
      }
    };

    // 发起聊天
    const handleChat = async item => {
      if (!item.userId) {
        ElMessage.warning('无法获取用户信息');
        return;
      }
      try {
        const conversation = await createSingleConversation(item.userId);
        const conversationId = conversation?.id || conversation;
        router.push({
          path: '/chat',
          query: {
            conversationId
          }
        });
      } catch (error) {
        ElMessage.error(error.message || '创建会话失败');
      }
    };

    // 查看聊天记录
    const handleViewChat = item => {
      if (item.conversationId) {
        router.push({
          path: '/chat',
          query: {
            conversationId: item.conversationId
          }
        });
      }
    };
    onMounted(() => {
      fetchData();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "用户需求管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理C端用户提交的需求，分配处理人或自行认领。")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, "待分配：" + _toDisplayString(statusCounts.value.pending), 1), _createElementVNode("span", _hoisted_5, "处理中：" + _toDisplayString(statusCounts.value.processing), 1), _createElementVNode("span", _hoisted_6, "已完成：" + _toDisplayString(statusCounts.value.completed), 1)])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": "",
          "refresh-loading": loading.value,
          onRefresh: fetchData
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = (...args) => _unref(triggerSearch) && _unref(triggerSearch)(...args)),
            class: "btn-primary"
          }, " 搜索 "), _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = (...args) => _unref(resetSearch) && _unref(resetSearch)(...args)),
            class: "btn-secondary"
          }, " 重置 ")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(searchForm).keyword = $event),
            type: "text",
            placeholder: "搜索需求描述、联系人...",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _cache[1] || (_cache[1] = _withKeys((...args) => _unref(triggerSearch) && _unref(triggerSearch)(...args), ["enter"]))
          }, null, 544), [[_vModelText, _unref(searchForm).keyword]]), _cache[7] || (_cache[7] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: _unref(searchForm).status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(searchForm).status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleFilterChange
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, opt => {
              return _createVNode(_component_el_option, {
                key: opt.value,
                label: opt.label,
                value: opt.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("table", _hoisted_11, [_cache[16] || (_cache[16] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "需求描述"), _createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "联系人"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "状态"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "处理人"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "提交时间"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "处理时间"), _createElementVNode("th", {
          class: "px-5 py-3 text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "data-table-row"
          }, [...(_cache[8] || (_cache[8] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-56"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-24"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-5 w-14 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-12"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-24"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-24"
          })], -1), _createElementVNode("td", {
            class: "data-table-td data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "mx-auto flex justify-center gap-2"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          }), _createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          }), _createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          })])], -1)]))]);
        }), 64)) : !demandList.value.length ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [...(_cache[9] || (_cache[9] = [_createElementVNode("td", {
          colspan: "7",
          class: "px-5 py-8 text-center text-sm text-slate-500"
        }, "暂无用户需求数据", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(demandList.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
            class: "data-table-cell-title line-clamp-2",
            title: item.description
          }, _toDisplayString(item.description || '暂无描述'), 9, _hoisted_15), item.handlerReply ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "data-table-cell-meta mt-1 truncate",
            title: item.handlerReply
          }, "回复：" + _toDisplayString(item.handlerReply), 9, _hoisted_16)) : _createCommentVNode("", true), getImageList(item).length ? (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getImageList(item).slice(0, 3), (img, idx) => {
            return _openBlock(), _createElementBlock("img", {
              key: idx,
              src: img,
              class: "h-10 w-10 rounded-md border border-slate-200 object-cover",
              alt: "凭证图片"
            }, null, 8, _hoisted_18);
          }), 128)), getImageList(item).length > 3 ? (_openBlock(), _createElementBlock("span", _hoisted_19, "+" + _toDisplayString(getImageList(item).length - 3), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(item.contactName || '未知用户'), 1), item.contactPhone ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(item.contactPhone), 1)) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_23, [_createElementVNode("span", {
            class: _normalizeClass(statusBadgeClass(item.status))
          }, _toDisplayString(statusText(item.status)), 3)]), _createElementVNode("td", _hoisted_24, _toDisplayString(item.handlerId || '-'), 1), _createElementVNode("td", _hoisted_25, _toDisplayString(formatTime(item.createTime)), 1), _createElementVNode("td", _hoisted_26, _toDisplayString(formatTime(item.handleTime)), 1), _createElementVNode("td", _hoisted_27, [_createElementVNode("div", _hoisted_28, [item.status === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleAssign(item),
            class: "table-action-button is-primary",
            title: "分配给",
            "aria-label": "分配给"
          }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
          })], -1)]))], 8, _hoisted_29)), [[_directive_permission, 'app:demand:assign']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleClaim(item),
            class: "table-action-button is-success",
            title: "领取",
            "aria-label": "领取"
          }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_30)), [[_directive_permission, 'app:demand:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleReject(item),
            class: "table-action-button is-danger",
            title: "拒绝",
            "aria-label": "拒绝"
          }, [...(_cache[12] || (_cache[12] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)]))], 8, _hoisted_31)), [[_directive_permission, 'app:demand:edit']])], 64)) : item.status === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("button", {
            onClick: $event => handleChat(item),
            class: "table-action-button is-teal",
            title: "发起聊天",
            "aria-label": "发起聊天"
          }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          })], -1)]))], 8, _hoisted_32), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleClose(item),
            class: "table-action-button is-neutral",
            title: "关闭",
            "aria-label": "关闭"
          }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          })], -1)]))], 8, _hoisted_33)), [[_directive_permission, 'app:demand:edit']])], 64)) : _createCommentVNode("", true), item.conversationId ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: $event => handleViewChat(item),
            class: "table-action-button is-indigo",
            title: "聊天记录",
            "aria-label": "聊天记录"
          }, [...(_cache[15] || (_cache[15] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
          })], -1)]))], 8, _hoisted_34)) : _createCommentVNode("", true), (item.status === 2 || item.status === 3) && !item.conversationId ? (_openBlock(), _createElementBlock("span", _hoisted_35, "-")) : _createCommentVNode("", true)])])]);
        }), 128))])])])]), _unref(pagination).total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: _unref(pagination),
          "page-sizes": [10, 20, 50],
          onPageChange: changePage,
          onSizeChange: changePageSize
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)]), _createVNode(DemandAssignModal, {
          ref_key: "assignModalRef",
          ref: assignModalRef,
          show: showAssignModal.value,
          "onUpdate:show": _cache[5] || (_cache[5] = $event => showAssignModal.value = $event),
          item: assignItem.value,
          onConfirm: handleAssignConfirm
        }, null, 8, ["show", "item"])]),
        _: 1
      });
    };
  }
};